<template>
  <CountryPage country="india" />
</template>